import React, {useState, useEffect} from "react";
import {
  MDBNavbar,
  MDBNavbarToggler,
  MDBIcon,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBContainer,
} from "mdb-react-ui-kit";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";
import { Button } from "../../components/StyledComponents";
import { HashLink } from "react-router-hash-link";
import bgImage from "../../assets/img/brand/HomePage_bg.jpg";
import { getBackground } from "../../api/UserAPI";


export default function BgImageWithNavbar() {
  const navigate = useNavigate();
  const [backgrounds, setBackgrounds] = useState([]);



  useEffect(() => {
    fetchBackgrounds();
  }, []);

  const fetchBackgrounds = async () => {
    try {
      const response = await getBackground();
      console.log('Fetched backgrounds:', response);
      if (Array.isArray(response)) {
        const Image =response[0]
        setBackgrounds(Image.image);
      } else {
        console.error('Unexpected response format:', response);
        setBackgrounds(bgImage); // Use default image in case of fetch error

      }
    } catch (error) {
      console.error('Failed to fetch backgrounds', error);
      setBackgrounds(bgImage);
    }
  };

  const handleImageError = () => {
    // const newBackgrounds = [...backgrounds];
    // newBackgrounds[index].image = defaultBgImage;
    setBackgrounds(bgImage);
  };



  return (
    <header style={{ paddingLeft: 0 }}>
      <div
        className=" p-5 bg-image intro5-section section"
        style={{
          backgroundImage: `url(${backgrounds})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover", // Added to ensure the image covers the entire container
          height: 700,
        }}
        onError={() => handleImageError()}
        

      >
        <div className="container mt-5">
          <div className="row row-cols-lg-2 row-cols-1 max-mb-n30">
            {/* Intro One Content Start */}
            <div className="col align-self-center max-mb-30" data-aos="fade-up">
              <div className="intro5-content text-center text-md-start ">
                <h2
                  className="title text-white"
                  style={{
                    marginTop: "50px",
                    fontWeight: "700",
                  }}
                >
                  Explore 100+ Training Courses for Individuals and
                  Organisations
                </h2>
                <div className="desc">
                  <p className="text-white">
                    We train ambitious individuals and organisations worldwide
                    and help them achieve impact through powerful training
                    courses.
                  </p>
                </div>

                <Button
                  style={{ marginTop: "35px" }}
                  onClick={() => navigate(`/courses`)}
                >
                  <i className="far fa-download me-3"></i> Explore our Courses
                </Button>
              </div>
            </div>
            {/* Intro One Content End */}

            {/* Intro One Course Start */}
            <div className="col max-mb-30" data-aos="fade-up">
              {/* Intro Image Start */}
              {/* <div className="intro5-image"></div> */}
              {/* Intro Image End */}
            </div>
            {/* Intro One Course End */}
          </div>
        </div>
        <div className="section-bottom-shape-three">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            version="1.1"
            preserveAspectRatio="none"
            width="100%"
            height="300px"
          >
            <path
              className="elementor-shape-fill"
              d="M100,6.21724894e-15 L100,79.7754703 C99.7919362,79.7904198 99.6381974,79.8027262 99.5387835,79.8123897 C99.4256772,79.823384 99.3041657,79.8260447 99.1946857,79.8368479 C98.0926947,79.9455898 96.8446759,80.1450278 96.0566669,80.3249475 C95.1164427,80.5396213 93.6651585,81.0424133 91.7028144,81.8333235 C91.1881986,82.0648898 90.6629331,82.3321219 90.1270181,82.6350198 C89.591103,82.9379178 88.7808989,83.4254899 87.6964058,84.0977361 L84.5866785,86.505496 C83.9146556,87.0756533 83.3999022,87.5308769 83.0424183,87.8711667 C82.6706034,88.2250983 82.3219339,88.542792 81.9256169,88.9363773 C81.5083908,89.3507275 81.0415644,89.840935 80.5708891,90.2075771 C80.5694243,90.2087181 79.879045,90.9348069 79.6966916,91.0931301 C79.6786428,91.1088004 79.619181,91.1783162 79.6134287,91.1806951 C79.5856944,91.1921647 79.4872823,91.3143998 79.2325655,91.5654126 C78.9778486,91.8164253 78.4398261,92.3343122 78.4004716,92.3632772 C78.3852088,92.3745107 78.392749,92.3842318 78.3758447,92.404756 C78.3491619,92.4371525 78.297362,92.4837356 78.2713401,92.5087419 C78.1637093,92.6121724 78.057958,92.7052899 77.9412752,92.8201952 C77.9165042,92.8445888 77.8915476,92.8692319 77.8664085,92.8941052 C77.5163916,93.2404218 77.1310001,93.6313644 76.71875,94.0148783 C75.2657705,95.366577 73.5033569,96.917444 71.8705734,97.9003807 C70.9731573,98.4406259 70.1135532,98.9247458 69.344824,99.2158182 C67.7865314,99.8058517 66.6383515,99.8725302 66.5625,99.8951541 C65.9370497,100.081705 65.026153,100.01931 63.8298099,99.7079704 C64.7659815,99.9771782 64.7185432,99.9771782 63.6874951,99.7079704 C63.3965705,99.6321197 63.0376491,99.5183032 62.6097313,99.3665209 C62.1818134,99.2147385 61.6838996,99.0249903 61.1209891,98.7972753 C59.9941681,98.3418454 58.6396419,97.7387141 57.1181201,96.9778705 C55.5965983,96.217027 53.9070814,95.2984811 52.2133199,94.1042828 C49.8257969,92.7160873 47.4271365,90.9522391 45.0242313,88.9127384 C42.6213261,86.8732377 40.2141753,84.5570845 37.802779,81.9642788 C35.3913826,79.371473 32.9757417,76.5020157 30.5558553,73.3569059 C28.1359689,70.2117961 25.711837,66.7900338 23.28346,63.0916189 C20.855083,59.393204 18.4224611,55.4171367 15.9855943,51.163417 C13.5487274,46.9096973 11.1076156,42.3783252 8.66225888,37.5693006 C6.21690217,32.760276 3.76730051,27.673599 1.31345391,22.3092695 C0.87515197,21.4126125 0.437072676,20.5157338 0,19.6186334 L0,6.21724894e-15 Z"
            ></path>
          </svg>
        </div>
      </div>
    </header>
  );
}
